import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { downloadAttachment } from '../../funciones/EmailFunction';

const MailAttachment = (props) => {
    const [icono, setIcono] = useState({
        icono: props.Icono,
        color: props.Color
    });

    return(
        <React.Fragment>
            <div className="custom-mt-10 attachment-file" title="Descargar este archivo"
            onClick={() => {
                setIcono ({ icono: "fa fa-spinner fa-spin", color: "000" })
                downloadAttachment(props.Email, props.Date, props.FileName, props.UId, (resp) => {
                    if(resp === "error") toast.error("Ocurrió un error al descargar el archivo",{autoClose: 4000});
                    setIcono ({ icono: props.Icono, color: props.Color })
                })
            }}>
                <div style={{fontSize: 10}}><i className={icono.icono} style={{color: icono.color}}></i> {props.Name}</div>
                <div className="text-muted" style={{fontSize: 10, marginLeft: 20}}>({props.Size})</div>
            </div>
        </React.Fragment>
    )
}

export default MailAttachment;


// WEBPACK FOOTER //
// ./src/views/Email/MailAttachment.jsx